<template>
	<div class="customerCheckVouch">
		<!-- <div class="content-menu" v-if="menuList.length>1">
			<div class="menu-item" :class="[current===index?'current':'']" v-for="(item,index) in menuList" :key="index"
				@click="handClick(index)">
				{{item.title}}
			</div>
		</div> -->
		<div class="content-view">
			<component :is="menuList[current].component" :auth="menuList[current].auth"></component>
		</div>
	</div>
</template>

<script>
	//import checkVouch from './CheckVouch/CheckVouch.vue';
	import vouchList from './VouchList/VouchList.vue';
	export default {
		data() {
			return {
				current: 0,
				menuList: [],
			}
		},
		computed: {
			menusData() {
				return this.$store.state.MenusData.Menus;
			}
		},
		created() {
			this.setMenuList();
		},
		methods: {
			setMenuList() {
				let NodeInfo = this.menusData.filter(item => item.NodeID === '18')[0].Nodes.filter(item => item.NodeID ==='163');
				
				this.menuList = NodeInfo.map(item => {
					item.title = item.NodeName;
					item.auth = item.Nodes && item.Nodes.map(item1 => item1.NodeName);
					// if (item.NodeID === '164') {
					// 	item.component = checkVouch;
					// }
					if (item.NodeID === '163') {
						item.component = vouchList;
					}
					return item;
				})
			},
			handClick(index) {
				this.current = index;
			}
		}
	}
</script>

<style scoped lang="less">
	.customerCheckVouch {
		//width: 100%;
		padding: 24px;
		min-height: 80vh;
		position: relative;
		background: #ffffff;

		.content-menu {
			display: flex;
			justify-content: center;
			user-select: none;
			cursor: pointer;

			.menu-item {
				width: 350px;
				height: 40px;
				line-height: 40px;
				text-align: center;
				box-sizing: border-box;
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-65 Medium, Alibaba PuHuiTi 20;
				font-weight: 400;
				color: #16181A;
				border: 1px solid #E6E8EB;
			}

			.current {
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-65 Medium, Alibaba PuHuiTi 20;
				font-weight: 400;
				color: #FFFFFF;
				background: #00266D;
				border: 1px solid #00266D;
			}

			// .menu-item:nth-child(2) {
			// 	border-left: 0px;
			// 	border-right: 0px;
			// }
		}

		.content-view {
			margin-top: 16px;
		}
	}
</style>